import { useState, useEffect, useRef } from 'react'
import { createReportTracker } from '../shared/lib/reportTracker'

const statusMap = {
    ok: { label: 'Исправно', color: '#059669', bg: '#D1FAE5', icon: 'ti-circle-check' },
    warning: { label: 'Некритичное', color: '#D97706', bg: '#FEF3C7', icon: 'ti-alert-circle' },
    critical: { label: 'Критичное', color: '#DC2626', bg: '#FEE2E2', icon: 'ti-alert-triangle' },
    na: { label: 'Н/П', color: '#6B7280', bg: '#F3F4F6', icon: 'ti-minus' },
}

const groupIcons = {
    'Двигатель и тех. жидкости': 'ti-engine',
    'Ходовая часть': 'ti-car',
    'Кузов и электрика': 'ti-bolt',
}

const reportStyles = `
.rp{min-height:100vh;background:#F3F5F9}
.rp-top{display:flex;align-items:center;justify-content:center;padding:12px 16px;background:white;box-shadow:0 1px 0 #E6EAF1}
.rp-body{max-width:680px;margin:0 auto;padding:16px;display:flex;flex-direction:column;gap:12px;box-sizing:border-box}
.rp-card{background:white;border-radius:20px;padding:18px 20px;box-shadow:0 1px 2px rgba(16,24,40,.04),0 6px 18px -8px rgba(16,24,40,.12)}
.rp-preview{display:flex;align-items:center;justify-content:center;gap:6px;padding:10px 14px;border-radius:14px;background:#FFF7ED;color:#9A3412;font-size:12px;font-weight:600;text-align:center}
.rp-hero{position:relative;overflow:hidden;isolation:isolate;padding:18px 20px 16px;background:linear-gradient(140deg,#1F64FF 0%,#0052FF 60%,#004AE6 100%);color:white}
.rp-hero::before{content:"";position:absolute;right:-40px;top:-70px;z-index:-1;width:170px;height:170px;border-radius:50%;background:rgba(255,255,255,.09)}
.rp-hero-label{margin:0 0 4px;font-size:11px;font-weight:500;color:rgba(255,255,255,.75)}
.rp-hero-car{margin:0 0 8px;font-size:20px;font-weight:800;line-height:1.2}
.rp-hero-row{display:flex;flex-wrap:wrap;align-items:center;gap:6px 16px}
.rp-hero-meta{display:inline-flex;align-items:center;gap:6px;font-size:13px;font-weight:600;color:rgba(255,255,255,.85)}
.rp-hero-meta i{font-size:13px;color:rgba(255,255,255,.6)}
.rp-info{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;padding:14px}
.rp-field{display:flex;align-items:center;gap:9px;min-width:0;padding:9px 11px;border-radius:12px;background:#F7F8FA}
.rp-field>i{display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;width:28px;height:28px;border-radius:9px;background:white;color:#0052FF;font-size:14px}
.rp-field div{min-width:0}
.rp-field p{margin:0;font-size:11px;color:#9CA3AF}
.rp-field b{display:block;margin-top:1px;font-size:13px;font-weight:600;color:#1A1A1A;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.rp-field[data-wide=true]{grid-column:1/-1}
.rp-title{display:flex;align-items:center;gap:10px;margin:0 0 12px}
.rp-title-icon{display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;width:32px;height:32px;border-radius:10px;background:#EEF3FF;color:#0052FF}
.rp-title-icon i{font-size:16px}
.rp-title-icon[data-tone=red]{background:#FEF2F2;color:#DC2626}
.rp-title-icon[data-tone=green]{background:#E7F8F0;color:#059669}
.rp-title-icon[data-tone=grey]{background:#F3F5F9;color:#6B7280}
.rp-title h2{margin:0;font-size:15px;font-weight:700;color:#1A1A1A}
.rp-title p{margin:1px 0 0;font-size:11px;color:#6B7280}
.rp-title .rp-badge{margin-left:auto}
.rp-badge{flex-shrink:0;font-size:11px;font-weight:600;padding:2px 9px;border-radius:999px;white-space:nowrap}
.rp-summary{background:linear-gradient(160deg,#EEF4FF 0%,#FFFFFF 70%)}
.rp-summary-text{margin:0;padding:14px 16px;border-radius:14px;background:white;box-shadow:inset 0 0 0 1px #DCE6FF;font-size:13px;color:#374151;line-height:1.6}
.rp-contact-label{margin:14px 0 8px;font-size:11px;color:#6B7280;text-align:center}
.rp-contacts{display:flex;gap:8px}
.rp-contacts a{flex:1;display:flex;align-items:center;justify-content:center;gap:6px;padding:12px;border-radius:12px;font-size:13px;font-weight:700;text-decoration:none}
.rp-contacts a i{font-size:15px}
.rp-call{background:#0052FF;color:white;box-shadow:0 8px 18px -10px rgba(0,82,255,.9)}
.rp-max{background:white;color:#0052FF;box-shadow:inset 0 0 0 1.5px #0052FF}
.rp-mileage{display:flex;align-items:center;justify-content:space-between;gap:12px}
.rp-title .rp-mileage-value{margin:0;font-size:24px;font-weight:800;color:#1A1A1A}
.rp-thumbs{display:flex;gap:8px;flex-wrap:wrap}
.rp-thumbs img{width:72px;height:72px;object-fit:cover;border-radius:12px;cursor:pointer;box-shadow:0 0 0 1px rgba(16,24,40,.08);transition:transform .15s}
.rp-thumbs img:hover{transform:scale(1.03)}
.rp-problems{display:flex;flex-direction:column;gap:8px}
.rp-problem{position:relative;padding:12px 12px 12px 15px;border-radius:14px;overflow:hidden}
.rp-problem::before{content:"";position:absolute;left:0;top:0;bottom:0;width:4px}
.rp-problem[data-status=critical]{background:#FEF2F2}
.rp-problem[data-status=critical]::before{background:#DC2626}
.rp-problem[data-status=warning]{background:#FFF8EB}
.rp-problem[data-status=warning]::before{background:#F59E0B}
.rp-problem-head{display:flex;align-items:center;justify-content:space-between;gap:8px}
.rp-problem-name{display:flex;align-items:center;gap:7px;min-width:0;font-size:12px;font-weight:600;color:#1A1A1A}
.rp-problem-name i{font-size:15px;flex-shrink:0}
.rp-problem .rp-thumbs{margin-top:10px}
.rp-group+.rp-group{margin-top:14px}
.rp-group-head{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:4px;padding:6px 10px;border-radius:10px;background:#F7F8FA}
.rp-group-head h3{display:flex;align-items:center;gap:6px;margin:0;font-size:10px;font-weight:700;color:#6B7280;text-transform:uppercase;letter-spacing:.08em}
.rp-group-head h3 i{font-size:13px;color:#9CA3AF}
.rp-item{display:flex;align-items:center;gap:8px;padding:6px 10px;font-size:12px;color:#4B5563}
.rp-item+.rp-item{border-top:1px solid #F3F5F9}
.rp-item i{font-size:15px;flex-shrink:0}
.rp-item[data-muted=true]{color:#9CA3AF}
.rp-footer{border-radius:20px;overflow:hidden;margin-bottom:4px;box-shadow:0 6px 18px -8px rgba(0,82,255,.45)}
.rp-footer-note{margin:0;padding:10px 20px;background:white;text-align:center;font-size:11px;color:#9CA3AF}
.rp-footer-main{position:relative;overflow:hidden;isolation:isolate;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:16px 20px;background:linear-gradient(140deg,#3B78FF 0%,#0052FF 60%,#0041CC 100%)}
.rp-footer-main::after{content:"";position:absolute;right:-30px;top:-50px;z-index:-1;width:130px;height:130px;border-radius:50%;background:rgba(255,255,255,.12)}
.rp-footer-main p{margin:0 0 2px;font-size:11px;color:rgba(255,255,255,.7);font-weight:500}
.rp-footer-main a{font-size:17px;font-weight:700;color:white;text-decoration:none;letter-spacing:.01em}
.rp-footer-badge{display:flex;flex-direction:column;align-items:center;gap:3px;color:rgba(255,255,255,.85)}
.rp-footer-badge i{display:inline-flex;align-items:center;justify-content:center;width:38px;height:38px;border-radius:12px;background:rgba(255,255,255,.16);font-size:20px}
.rp-footer-badge span{font-size:10px;color:rgba(255,255,255,.7);font-weight:500}
.rp-viewer{position:fixed;inset:0;z-index:1000;display:flex;align-items:center;justify-content:center;padding:20px;background:rgba(10,14,25,.92)}
.rp-viewer img{max-width:100%;max-height:100%;object-fit:contain;border-radius:12px}
.rp-viewer button{position:absolute;top:16px;right:16px;display:flex;align-items:center;justify-content:center;width:40px;height:40px;padding:0;border:0;border-radius:12px;background:rgba(255,255,255,.14);color:white;cursor:pointer}
.rp-viewer button i{font-size:20px}
.rp a:focus-visible,.rp button:focus-visible,.rp img:focus-visible{outline:2px solid #0052FF;outline-offset:2px}
@media(max-width:380px){.rp-info{grid-template-columns:minmax(0,1fr)}.rp-field[data-wide=true]{grid-column:auto}}
`

function AdditionalPhotos({ photos, onPreview }) {
    return (
        <div className="rp-card">
            <div className="rp-title">
                <span className="rp-title-icon" data-tone="grey"><i className="ti ti-zoom-check" aria-hidden="true" /></span>
                <div>
                    <h2>Дополнительный осмотр</h2>
                    <p>Прочие элементы · {photos.length} фото</p>
                </div>
            </div>
            <div className="rp-thumbs">
                {photos.map(photo => (
                    <img key={photo.id} src={photo.path} alt="фото" onClick={() => onPreview(photo.path, photo.id)} />
                ))}
            </div>
        </div>
    )
}

export default function Report() {
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [previewPhoto, setPreviewPhoto] = useState(null)

    const trackerRef = useRef(null)
    const endRef = useRef(null)
    const track = (type, payload={}) => trackerRef.current?.event(type,payload)

    const trackPhotoOpen = (photoPath, photoId) => {
        const photo=data?.tracking?.photos?.find(p=>p.path===photoPath || p.key===`id:${photoId}`)
        setPreviewPhoto({path:photoPath,key:photo?.key})
    }

    useEffect(() => {
        const isPreviewRoute = window.location.pathname.startsWith('/report/preview/')
        const token = isPreviewRoute
            ? window.location.pathname.split('/report/preview/')[1]
            : window.location.pathname.split('/report/')[1]
        let disposed=false
        const sessionToken = localStorage.getItem('token')
        const load=async()=>{
            try {
                if (!token) throw new Error('Неверная ссылка')
                if (isPreviewRoute && !sessionToken) throw new Error('Для предпросмотра войдите в рабочую учётную запись')
                const response=await fetch((isPreviewRoute?'/api/reports/preview/':'/api/reports/get/')+token,{
                    headers:isPreviewRoute?{Authorization:`Bearer ${sessionToken}`}:{},
                })
                const result=await response.json()
                if (!response.ok || result.message) throw new Error(result.message||'Ошибка загрузки')
                if (disposed) return
                setData(result); setLoading(false)
                // A telemetry failure must never replace a successfully loaded report.
                try {
                    trackerRef.current=createReportTracker({token,preview:isPreviewRoute||Boolean(result.is_preview),enabled:result.tracking_enabled===true,isAtEnd:()=>{
                        const rect=endRef.current?.getBoundingClientRect()
                        return Boolean(rect && rect.top>=0 && rect.bottom<=window.innerHeight)
                    }})
                    trackerRef.current.start()
                } catch {
                    try { trackerRef.current?.stop() } catch { /* failed partial initialization */ }
                    trackerRef.current=null
                    console.warn('Не удалось запустить аналитику отчёта')
                }
            } catch (failure) {
                if (!disposed) { setError(failure.message||'Ошибка загрузки'); setLoading(false) }
            }
        }
        void load()
        return ()=>{disposed=true;trackerRef.current?.stop();trackerRef.current=null}
    }, [])

    if (loading) return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F3F5F9' }}>
            <p style={{ color: '#6B7280' }}>Загрузка отчёта...</p>
        </div>
    )

    if (error) return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F3F5F9' }}>
            <p style={{ color: '#DC2626' }}>{error}</p>
        </div>
    )

    const { order, results, intake = {} } = data
    const mileageResult = intake.mileage !== null && intake.mileage !== undefined
        ? { comment: String(intake.mileage), photos: intake.photos || [] }
        : null
    const additionalPhotos = intake.additional_photos || []
    const filteredResults = results
    const groups = [...new Set(filteredResults.map(r => r.group_name))]
    const criticalItems = filteredResults.filter(r => r.status === 'critical')
    const warningItems = filteredResults.filter(r => r.status === 'warning')
    const okCount = filteredResults.filter(r => r.status === 'ok').length
    const hasProblems = criticalItems.length > 0 || warningItems.length > 0
    const sideText = (r, short) => r.side && r.side !== 'none' ? (short ? ' · ' : ' (') + (r.side === 'left' ? 'лев.' : 'прав.') + (short ? '' : ')') : ''
    const reportDate = new Date(data.created_at).toLocaleDateString('ru-RU', { timeZone: 'Europe/Moscow' })
    const fields = [
        { icon: 'ti-user', label: 'Клиент', value: order.client_name },
        order.client_phone && { icon: 'ti-phone', label: 'Телефон', value: order.client_phone },
        { icon: 'ti-tool', label: 'Механик', value: order.mechanic_name || '-' },
        { icon: 'ti-user-star', label: 'Мастер', value: order.master_name || '-' },
        order.vin && { icon: 'ti-id', label: 'VIN', value: order.vin, wide: true },
    ].filter(Boolean)
    // если плиток без пары нечётное число — последняя растягивается на всю ширину, чтобы не было дыры
    const narrow = fields.filter(item => !item.wide)
    if (narrow.length % 2 === 1) narrow[narrow.length - 1].wide = true
    const listGroup = (status, badge, muted) => groups.map(group => {
        const list = filteredResults.filter(r => r.group_name === group && r.status === status)
        if (list.length === 0) return null
        return (
            <div key={group} className="rp-group">
                <div className="rp-group-head">
                    <h3>{groupIcons[group] && <i className={'ti ' + groupIcons[group]} aria-hidden="true" />}{group}</h3>
                    {badge}
                </div>
                {list.map(r => (
                    <div key={r.id} className="rp-item" data-muted={muted}>
                        <i className={`ti ${muted ? 'ti-minus' : 'ti-circle-check'}`} style={{ color: muted ? '#C5CCD8' : '#10B981' }} aria-hidden="true" />
                        {r.item_name}{sideText(r, true)}
                    </div>
                ))}
            </div>
        )
    })

    return (
        <div className="rp">
            <style>{reportStyles}</style>

            {previewPhoto && (
                <div className="rp-viewer" onClick={() => setPreviewPhoto(null)}>
                    <img src={previewPhoto.path} alt="предпросмотр"
                        onLoad={()=>{if(previewPhoto.key) track('photo_open',{photo_key:previewPhoto.key})}} />
                    <button type="button" aria-label="Закрыть" onClick={() => setPreviewPhoto(null)}><i className="ti ti-x" aria-hidden="true" /></button>
                </div>
            )}

            <div className="rp-top">
                <img src="/logo.png" alt="CoFresh" style={{ height: '20px', filter: 'invert(1)' }} />
            </div>

            <div className="rp-body">

                {data.is_preview && (
                    <div className="rp-preview">
                        <i className="ti ti-eye" aria-hidden="true" />
                        Режим проверки — переходы и действия не влияют на индекс интереса клиента
                    </div>
                )}

                <div className="rp-card" style={{ padding: 0, overflow: 'hidden' }}>
                    <div className="rp-hero">
                        <p className="rp-hero-label">Отчёт о диагностике</p>
                        <p className="rp-hero-car">{order.car_brand} {order.car_model} {order.car_year}</p>
                        <div className="rp-hero-row">
                            {order.plate && <span className="rp-hero-meta"><i className="ti ti-car" aria-hidden="true" />{order.plate}</span>}
                            <span className="rp-hero-meta" style={{ fontWeight: 500 }}><i className="ti ti-calendar" aria-hidden="true" />{reportDate}</span>
                        </div>
                    </div>
                    <div className="rp-info">
                        {fields.map(item => (
                            <div key={item.label} className="rp-field" data-wide={item.wide}>
                                <i className={`ti ${item.icon}`} aria-hidden="true" />
                                <div><p>{item.label}</p><b>{item.value}</b></div>
                            </div>
                        ))}
                    </div>
                </div>

                {order.mechanic_summary && (
                    <div className="rp-card rp-summary">
                        <div className="rp-title">
                            <span className="rp-title-icon" style={{ background: '#0052FF', color: 'white' }}><i className="ti ti-file-text" aria-hidden="true" /></span>
                            <div>
                                <h2 style={{ fontSize: '13px' }}>Итоговое заключение</h2>
                                <p>Подтвердил: {order.summary_confirmer_name || 'сотрудник сервиса'}</p>
                            </div>
                        </div>
                        <p className="rp-summary-text">{order.mechanic_summary}</p>
                        {(order.master_phone || order.master_max_url) && (
                            <>
                                <p className="rp-contact-label">Остались вопросы? Свяжитесь с нами</p>
                                <div className="rp-contacts">
                                    {order.master_phone && (
                                        <a href={'tel:' + order.master_phone} className="rp-call"
                                            onClick={() => track('action_call',{target:'master'})}>
                                            <i className="ti ti-phone" aria-hidden="true" /> Позвонить
                                        </a>
                                    )}
                                    {order.master_max_url && (
                                        <a href={order.master_max_url} className="rp-max"
                                            onClick={() => track('action_max')}
                                            target="_blank" rel="noreferrer">
                                            <i className="ti ti-message" aria-hidden="true" /> В МАКС
                                        </a>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                )}

                {mileageResult && (
                    <div className="rp-card">
                        <div className="rp-mileage">
                            <div className="rp-title" style={{ margin: 0 }}>
                                <span className="rp-title-icon"><i className="ti ti-gauge" aria-hidden="true" /></span>
                                <div>
                                    <p style={{ margin: 0, fontSize: '12px', color: '#9CA3AF' }}>Пробег при приёмке</p>
                                    <p className="rp-mileage-value">{parseInt(mileageResult.comment).toLocaleString('ru-RU')} км</p>
                                </div>
                            </div>
                            {mileageResult.photos && mileageResult.photos.length > 0 && (
                                <div className="rp-thumbs">
                                    {mileageResult.photos.map(photo => (
                                        <img key={photo.id} src={photo.path} alt="одометр" onClick={() => trackPhotoOpen(photo.path, photo.id)} />
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {hasProblems && (
                    <div className="rp-card">
                        <div className="rp-title">
                            <span className="rp-title-icon" data-tone="red"><i className="ti ti-alert-triangle" aria-hidden="true" /></span>
                            <div>
                                <h2>Требует внимания</h2>
                                <p>Пункты, на которые стоит обратить внимание</p>
                            </div>
                        </div>
                        <div className="rp-problems">
                            {[...criticalItems, ...warningItems].map(r => (
                                <div key={r.id} className="rp-problem" data-status={r.status}>
                                    <div className="rp-problem-head">
                                        <span className="rp-problem-name">
                                            <i className={'ti ' + (statusMap[r.status] ? statusMap[r.status].icon : '')} style={{ color: statusMap[r.status] ? statusMap[r.status].color : '#6B7280' }} aria-hidden="true" />
                                            {r.item_name}{sideText(r, false)}
                                        </span>
                                        <span className="rp-badge" style={{ background: 'white', color: statusMap[r.status] ? statusMap[r.status].color : '#6B7280' }}>
                                            {statusMap[r.status] ? statusMap[r.status].label : ''}
                                        </span>
                                    </div>
                                    {r.photos && r.photos.length > 0 && (
                                        <div className="rp-thumbs">
                                            {r.photos.map(photo => (
                                                <img key={photo.id} src={photo.path} alt="фото" onClick={() => trackPhotoOpen(photo.path, photo.id)} />
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {okCount > 0 && (
                    <div className="rp-card">
                        <div className="rp-title">
                            <span className="rp-title-icon" data-tone="green"><i className="ti ti-circle-check" aria-hidden="true" /></span>
                            <div>
                                <h2>Без дефектов</h2>
                                <p>Проверено и исправно · {okCount}</p>
                            </div>
                        </div>
                        {listGroup('ok', <span className="rp-badge" style={{ background: '#D1FAE5', color: '#059669' }}>Исправно</span>, false)}
                    </div>
                )}

                {filteredResults.filter(r => r.status === 'na').length > 0 && (
                    <div className="rp-card">
                        <div className="rp-title">
                            <span className="rp-title-icon" data-tone="grey"><i className="ti ti-minus" aria-hidden="true" /></span>
                            <div>
                                <h2>Не предусмотрено</h2>
                                <p>Не применимо для этого автомобиля</p>
                            </div>
                        </div>
                        {listGroup('na', <span className="rp-badge" style={{ background: '#F3F4F6', color: '#6B7280' }}>Н/П</span>, true)}
                    </div>
                )}

                {additionalPhotos.length > 0 && (
                    <AdditionalPhotos photos={additionalPhotos} onPreview={trackPhotoOpen} />
                )}

                <div className="rp-footer">
                    <p className="rp-footer-note">Отчёт сформирован автоматически системой диагностики Fresh</p>
                    <div className="rp-footer-main">
                        <div>
                            <p>Служба контроля качества</p>
                            <a href="tel:+78006006109">+7 800 600-61-09</a>
                        </div>
                        <div className="rp-footer-badge">
                            <i className="ti ti-phone-call" aria-hidden="true" />
                            <span>бесплатно</span>
                        </div>
                    </div>
                </div>

                <div ref={endRef} aria-hidden="true" style={{height:1}} />
            </div>
        </div>
    )
}
